import React from 'react';

import './Copyright.css';

const Copyright = () => (
    <p className="copyright">Copyright &copy; 2021 HashEx, Inc.</p>
)

export default Copyright;